"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.search");
var _allianceAuthorization = require("@/api/allianceAuthorization");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      loadConfigData: {},
      form: {
        tbMemberId: null,
        tbPid: null,
        tbAppKey: null,
        tbAppSecret: null,
        tbUserNick: null,
        tbExpireTime: null,
        jdUnionId: null,
        pddClientId: null,
        pddClientSecret: null,
        pddMediaId: null,
        pddDuoId: null,
        wphAppKey: null,
        wphAppSecret: null,
        wphPid: null
      },
      rules: {
        tbMemberId: [{
          required: true,
          message: '请输入淘宝联盟ID',
          trigger: 'blur'
        }],
        tbPid: [{
          required: true,
          message: '请输入淘宝联盟推广位',
          trigger: 'blur'
        }],
        // tbAppKey: [{ required: true, message: '请输入淘宝联盟appKey', trigger: 'blur' }],
        // tbAppSecret: [{ required: true, message: '请输入淘宝联盟appSecret', trigger: 'blur' }],
        jdUnionId: [{
          required: true,
          message: '京东联盟-联盟ID',
          trigger: 'blur'
        }],
        pddClientId: [{
          required: true,
          message: '多多进宝-ClientId',
          trigger: 'blur'
        }],
        pddClientSecret: [{
          required: true,
          message: '多多进宝-ClientSecret',
          trigger: 'blur'
        }],
        pddMediaId: [{
          required: true,
          message: '多多进宝-媒体ID',
          trigger: 'blur'
        }],
        pddDuoId: [{
          required: true,
          message: '多多进宝-多多客ID',
          trigger: 'blur'
        }],
        wphAppKey: [{
          required: true,
          message: '唯品会-appKey',
          trigger: 'blur'
        }],
        wphAppSecret: [{
          required: true,
          message: '唯品会-appSecret',
          trigger: 'blur'
        }],
        wphPid: [{
          required: true,
          message: '唯品会-推广位',
          trigger: 'blur'
        }]
      },
      platformType: null,
      dialogVisible: false,
      title: '',
      platformName: {
        'TB': '淘宝编辑',
        'JD': '京东编辑',
        'PDD': '拼多多编辑',
        'WPH': '唯品会编辑'
      },
      CaseConversion: {
        'jd': 'JD',
        'tb': 'TB',
        'pdd': 'PDD',
        'wph': 'WPH'
      }
    };
  },
  created: function created() {
    this.loadConfigApi();
    var urlParams = new URLSearchParams(window.location.search);
    var code = urlParams.get('code'); // 获取 code 的值
    var state = urlParams.get('state'); // 获取 code 的值
    var unionCode = urlParams.get('unionCode'); // 获取 code 的值
    console.log(code, state, unionCode);
    var authCode = localStorage.getItem('authCode') ? JSON.parse(localStorage.getItem('authCode')) : '';
    if (code && code !== authCode) {
      localStorage.setItem('authCode', JSON.stringify(code));
      this.authCallback(this.CaseConversion[unionCode], code, state);
    }
  },
  methods: {
    loadConfigApi: function () {
      var _loadConfigApi = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {};
              _context.n = 1;
              return (0, _allianceAuthorization.loadConfig)(params);
            case 1:
              res = _context.v;
              this.loadConfigData = res.data;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadConfigApi() {
        return _loadConfigApi.apply(this, arguments);
      }
      return loadConfigApi;
    }(),
    saveConfigApi: function () {
      var _saveConfigApi = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(params) {
        var res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _allianceAuthorization.saveConfig)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.onClose();
                this.loadConfigApi();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function saveConfigApi(_x) {
        return _saveConfigApi.apply(this, arguments);
      }
      return saveConfigApi;
    }(),
    // 获取授权地址
    genOauthUrl: function () {
      var _genOauthUrl2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(unionCode) {
        var params, res, url, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                unionCode: unionCode
              };
              _context3.n = 1;
              return (0, _allianceAuthorization.genOauthUrl)(params);
            case 1:
              res = _context3.v;
              console.log('res', res);
              if (res.code === 0) {
                url = res.data.authUrl;
                location.href = url;
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }));
      function genOauthUrl(_x2) {
        return _genOauthUrl2.apply(this, arguments);
      }
      return genOauthUrl;
    }(),
    // 写入
    authCallback: function () {
      var _authCallback2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(unionCode, code, state) {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = {
                unionCode: unionCode,
                code: code,
                state: state
              };
              _context4.n = 1;
              return (0, _allianceAuthorization.authCallback)(params);
            case 1:
              res = _context4.v;
              console.log('res', res);
              if (res.code === 0) {
                if (res.data) {
                  this.loadConfigApi();
                  this.$notify.success({
                    title: '温馨提示',
                    message: '操作成功'
                  });
                } else {
                  this.$notify.error({
                    title: '温馨提示',
                    message: '操作失败'
                  });
                }
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function authCallback(_x3, _x4, _x5) {
        return _authCallback2.apply(this, arguments);
      }
      return authCallback;
    }(),
    // 更新授权
    UpdateAuthorization: function UpdateAuthorization(type) {
      console.log('type', type);
      this.genOauthUrl(type);
    },
    onEditor: function onEditor(val) {
      console.log('val----', val);
      this.platformType = val;
      this.title = this.platformName[val];
      if (this.platformType === 'TB') {
        this.form.tbMemberId = this.loadConfigData.tbMemberId;
        this.form.tbPid = this.loadConfigData.tbPid;
        this.form.tbAppKey = this.loadConfigData.tbAppKey;
        this.form.tbAppSecret = this.loadConfigData.tbAppSecret;
        // this.form.tbUserNick = this.loadConfigData.tbUserNick
        // this.form.tbExpireTime = this.loadConfigData.tbExpireTime
      }
      if (this.platformType === 'JD') {
        this.form.jdUnionId = this.loadConfigData.jdUnionId;
      }
      if (this.platformType === 'PDD') {
        this.form.pddClientId = this.loadConfigData.pddClientId;
        this.form.pddClientSecret = this.loadConfigData.pddClientSecret;
        this.form.pddMediaId = this.loadConfigData.pddMediaId;
        this.form.pddDuoId = this.loadConfigData.pddDuoId;
      }
      if (this.platformType === 'WPH') {
        this.form.wphAppKey = this.loadConfigData.wphAppKey;
        this.form.wphAppSecret = this.loadConfigData.wphAppSecret;
        this.form.wphPid = this.loadConfigData.wphPid;
      }
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.resetForm('formRef');
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var params = {
            unionCode: _this.platformType
          };
          if (_this.platformType === 'TB') {
            params.tbMemberId = _this.form.tbMemberId;
            params.tbPid = _this.form.tbPid;
            params.tbAppKey = _this.form.tbAppKey;
            params.tbAppSecret = _this.form.tbAppSecret;
          }
          if (_this.platformType === 'JD') {
            params.jdUnionId = _this.form.jdUnionId;
          }
          if (_this.platformType === 'PDD') {
            params.pddClientId = _this.form.pddClientId;
            params.pddClientSecret = _this.form.pddClientSecret;
            params.pddMediaId = _this.form.pddMediaId;
            params.pddDuoId = _this.form.pddDuoId;
          }
          if (_this.platformType === 'WPH') {
            params.wphAppKey = _this.form.wphAppKey;
            params.wphAppSecret = _this.form.wphAppSecret;
            params.wphPid = _this.form.wphPid;
          }
          _this.$confirm('是否确认确认修改联盟配置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this.saveConfigApi(params);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.form = {
        tbMemberId: null,
        tbPid: null,
        tbAppKey: null,
        // tbUserNick: null,
        // tbExpireTime: null,
        tbAppSecret: null,
        jdUnionId: null,
        pddClientId: null,
        pddClientSecret: null,
        pddMediaId: null,
        pddDuoId: null,
        wphAppKey: null,
        wphAppSecret: null,
        wphPid: null
      };
      this.$refs[formName].resetFields();
    }
  }
};